import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=71f6a060&scoped=true&"
import script from "./HelpMenu.vue?vue&type=script&lang=js&"
export * from "./HelpMenu.vue?vue&type=script&lang=js&"
import style0 from "./HelpMenu.vue?vue&type=style&index=0&id=71f6a060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6a060",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemGroup,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f6a060')) {
      api.createRecord('71f6a060', component.options)
    } else {
      api.reload('71f6a060', component.options)
    }
    module.hot.accept("./HelpMenu.vue?vue&type=template&id=71f6a060&scoped=true&", function () {
      api.rerender('71f6a060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/HelpMenu.vue"
export default component.exports